<template lang="pug">
  #app
    #page
      #header
        #logo.logo
          img(:src="require(`@/assets/img/logo.png`)")  
        div
          h1.heading Dauga Spirit
          img(:src="require(`@/assets/img/transformation.png`)")  
          .placendate
            .date 
            .place 
        nav.noselect 
          input#nav.hidden(type='checkbox' v-model="menu")
          label.nav-btn(for='nav') 
            .spaces(style="display:none")
            .icon
              i
              i
              i
          .nav-wrapper
            ul  
              li(v-for="(page, index) in orderBy(pages, 'id')"  @click="menuMethod()"  v-if="page.published" ) 
                router-link(:to="page.url")
                 span {{ page.name}} 
      router-view.text
</template>
<script>
import Vue2Filters from 'vue2-filters'


export default {
    mixins: [Vue2Filters.mixin],
    logo: '#logo',
    components: {

    },
    data() {
        return {
            window: { width: 0, height: 0 },
            menu: false,
            pages: [{name: "About", url: "/",published: true},{name: "Values", url: "values", published: true},{name: "Concepts", url: "concepts", published: true}, {name: "Vision", url: "vision", published: false}, {name: "Music", url: "music", published: true}, {name: "Join", url: "join", published: false} ]
        }
    },
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
      handleResize() {
          this.window.width = window.innerWidth;
          this.window.height = window.innerHeight;
      },
      menuMethod() {
        if (this.window.width < 600 ){
          this.menu = !this.menu
           //console.log('done')
        }
      }
    },
    watch: {
      // whenever active changes, this function will run
      menu: function () {
        document.body.style.overflow = this.menu ? 'hidden' : '';
        document.body.style.margin = this.menu ? '0px 15px 0px 0px' : '';
      }
    }
}
</script>
<style lang="sass">

//* @import url('https://fonts.googleapis.com/css2?family=Pangolin&display=swap')
@font-face 
  font-family: "Avenir Next"
  font-weight: bold
  src: url("assets/fonts/AvenirNextCyr-Bold.woff") format("woff2")

@font-face 
  font-family: "Avenir Next"
  font-weight: normal
  src: url("assets/fonts/avenir-next-regular.woff") format("woff2")

@import url('https://fonts.googleapis.com/css2?family=Lato&display=swap')

body
  color: rgb(17 24 39)
  font-family: "Avenir Next", sans-serif
  overflow: hidden !important

#header, .wrapper 
  flex: 0 1 auto

a 
  color: rgb(17 24 39)
a img 
  max-width: 500px

fieldset 
  border: none
#app 
  display: flex
  flex-flow: column
  height: 100vh
  overflow-y: auto
  background: #fff
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-align: center
  width: 100%
  position: absolute
  top: 0
  bottom: 0
  background-image: url("assets/img/fog2023.png")
  background-size: cover
  background-repeat: no-repeat


.video_contain 
  position: fixed
  left: 0
  top: 0
  width: 100%
  height: 100%
  z-index: -10

.video 
  position: absolute
  top: -9999px
  bottom: -9999px
  left: -9999px
  right: -9999px
  margin: auto
  height: inherit

#page 
  //display: flex !important
  flex-flow: column
  verflow-y: auto
  flex: 1 1 auto

#logo
  z-index: 9999
  margin-top: 60px
#logo img
  width: 100px
  position: relative
  z-index: 9999

.content
  margin: auto
  display: flex
  flex-flow: column
  flex: 1 1 auto
  padding: 0
  //padding: 10px 20px 100px 20px

.wrapper 
  font-size: 1.2em
  max-width: 600px
  padding: 0 20px 0 20px
  margin: auto
.text 
  text-align: left
  font-size: 20px
  padding-left: 50px
  line-height: 1.3em
  max-width: 600px
  margin: auto
  color: #253f65
  font-family: 'Lato', sans-serif
  text-align: left
  font-weight: 600
  padding-right: 30px
  padding-bottom: 80px
  ul li 
    margin-bottom: 20px
  ul 
    list-style-type: circle
  hr 
   display: none
li
  list-style: disc
li.list-none 
  list-style: none
.heading 
  font-size: 48px
h1
  font-weight: bold
  margin-bottom: 12px

h3
  margin-bottom: -12px
  padding-top: 28px
  font-weight: 900
  color: rgb(17, 24, 39)
  text-transform: uppercase
  font-family: "Avenir Next", sans-serif !important

.noselect 
  -webkit-touch-callout: none
    -webkit-user-select: none
     -khtml-user-select: none
       -moz-user-select: none
        -ms-user-select: none
            user-select: none


.date
  margin-top: 7px
  font-size: 24px
  font-weight: bold
.place 
  margin-top: 7px
.joinpopup
    position: fixed
    top: 0
    left: 0
    height: 100%
    min-width: 100%
    width: 100%
    z-index: 9999
    opacity: 1
    display: flex
    align-items: center
    justify-content: center
.joinpopup.text
  text-align: center
  color: #fff
// Nav

nav 
  position: relative
  display: flex
  justify-content: center
  .nav-wrapper 
     display: flex
     margin: 0px auto 12px auto
     padding-top: 20px
  a 
    color: #314E79
    font-size: 20px
    text-decoration: none
    cursor: pointer
    
.router-link-exact-active
      color: rgb(17 24 39)
nav ul
  margin-top: 0px
  width: auto
  padding-left: 0px


  li
    display: inline-block
    float: left

    a
      display: inline-block
      outline: none
      text-transform: uppercase
      text-decoration: none
      font-size: 28px
      letter-spacing: 0px
      font-weight: bold
@media screen and (min-width: 600px)
  nav
    li:not(:last-child)
      margin-right: 24px
@media screen and (max-width: 600px)
  #video
    transform: translate(calc(-50% + 10px), -50%)
  .text 
    margin-top: 20px
  .nav-btn 
    position: fixed
    margin-right: 20px
  textarea
    width: 200px
  .text
    padding-left: 20px
  .joinpopup
    max-width: 10%
  .nav-wrapper
    position: fixed
    top: 0
    width: 100%
    height: 100%
    z-index: -1
    background: #FFF
    opacity: 0
    transition: all 0s ease

    ul
      position: relative
      top: 0
      margin: 200px auto 
      padding-left: 5px
      max-width: 100px

      li
        display: table-row
        float: none
        width: 100%
        text-align: center
        margin-bottom: 10px
        //text-shadow: 0px 0px 20px black
        &:nth-child(1) a
          transition-delay: 0.2s

        &:nth-child(2) a
          transition-delay: 0.3s

        &:nth-child(3) a
          transition-delay: 0.4s

        &:nth-child(4) a
          transition-delay: 0.5s

        &:not(:first-child)
          margin-left: 0

        a
          padding: 10px 24px
          opacity: 0
          color: #314E79
          font-size: 20px
          //font-weight: 600
          letter-spacing: 1.2px
          transform: translateX(-20px)
          transition: all 0.2s ease

  .nav-btn
    right: 10px
    top: 10px
    margin-right: 30px
    height: 48px
    cursor: pointer
    z-index: 9998
    border-radius: 50%
    display: flex
    .spaces 
      margin-top: -6px
      margin-right: -5px
      font-size: 20px
      display: inline-flex !important
      justify-content: center
      flex-flow: column

    i
      display: block
      width: 20px
      height: 2px

      background: #314E79
      border-radius: 2px
      margin-left: 14px

      &:nth-child(1)
        margin-top: 16px

      &:nth-child(2)
        margin-top: 4px
        opacity: 1

      &:nth-child(3)
        margin-top: 4px

#nav:checked
  + .nav-btn
    .icon
      transform: rotate(45deg) translateX(-6px) translateY(-2px) 
    i
      background: #000
      color: red
      transition: transform 0.2s ease

      &:nth-child(1)
        transform: translateY(6px) rotate(180deg)

      &:nth-child(2)
        opacity: 0

      &:nth-child(3)
        transform: translateY(-6px) rotate(90deg)

  ~ .nav-wrapper
    z-index: 9990
    margin: auto
    opacity: 1

    ul li a
      opacity: 1
      //transform: translateX(0)
nav 
  justify-content: flex-end
.hidden
  display: none

</style>
